import { defineStore } from "pinia";
import type * as Models from "../../models";
import { v4 as uuidv4 } from "uuid";
import * as Enums from "../../enums";
import type { Settings } from "../../models/Settings";
import {
  getGame,
  saveGame,
  saveTurns,
  getGames, 
  saveSettings
} from "~/services/gameServices";

export const useGameStore = defineStore("gameStore", {
  state: () => ({
    game: {} as Models.Game,
    gameHistory: [] as Models.Game[],
  }),
  actions: {
    initializeGame() {
      //this.game = new Models.Game(uuidv4(), [], Enums.ExchangeRateMode.Random);
      this.game = {
        id: uuidv4(),
        settings: {
          exchangeRateMode: Enums.ExchangeRateMode.PlayerTurn,
          eventsEnabled: true,
          eventsIntensity: 10
        } as Settings,
        created: new Date(),
      } as Models.Game;
      //this.game = new Models.Game();
    },
    newGame() {
      const user = useSupabaseUser();

      //default new game
      this.game = {} as Models.Game;
      this.game.id = uuidv4();
      if (user.value) this.game.userID = user.value.id;
      this.game.code = generateRandomString(6);
      this.game.settings = {
        exchangeRateMode: Enums.ExchangeRateMode.PlayerTurn,
        eventsEnabled: true,
        eventsIntensity: 10
      } as Settings;
      //this.game.players = [{ id: uuidv4(), name: 'bradly'}, { id: uuidv4(), name: 'clay'}, { id: uuidv4(), name: 'benji'}];
      this.game.players = [];
      this.game.turns = [];
      this.game.created = new Date();
    },
    async getGame(id: string) {
      //go get the game if not already set
      //if (this.game.id === undefined) {
      const gameResult = await getGame(id);
      if (gameResult.success === true) {
        //test superjson auto mapping
        //   var rawData = superjson.stringify(gameResult.data);
        //   const betterDataTest = superjson.deserialize(gameResult.data as SuperJSONResult) // preserves Dates, Maps, etc.
        //   const parsedGame: Models.Game = superjson.parse(rawData);

        //zod attempt
        //   try {
        //     const game = GameSchema.parse(JSON.stringify(gameResult.data));
        //     this.game = game as Models.Game;
        //   } catch (err) {
        //     if (err instanceof z.ZodError) {
        //       console.error("Validation failed", err.errors);
        //     }
        //   }

        const fixedDate = convertIsoDates(gameResult.data);
        this.game = fixedDate as Models.Game;

        //    //works
        //   this.game = gameResult.data as Models.Game;

        //if turns are null, set to empty list
        if (this.game.turns == null) this.game.turns = [];

        //   //fix date mapping - works but ugly
        //   const newTurns = this.game.turns.map((turn) => ({
        //     ...turn,
        //     startTurn: new Date(turn.startTurn!),
        //     endTurn: turn.endTurn ? new Date(turn.endTurn!) : undefined,
        //   }));
        //   this.game.turns = newTurns;
      }
      //}

      //if turns are null, set to empty list
      //if (this.game.turns == null) this.game.turns = [];

      console.log("Game loaded: ", this.game);
    },
    async getGames(userID: string) {
      const gameHistoryResult = await getGames(userID);
      if (gameHistoryResult.success === true) {
        const gameList: Models.Game[] = [];
        const games = gameHistoryResult.data as Models.Game[];
        for (const tempGame of games) {
          const fixedDateGame: Models.Game = convertIsoDates(tempGame) as Models.Game;
          if (tempGame.turns == null) tempGame.turns = [];
          gameList.push(fixedDateGame);
        }
        this.gameHistory = gameList;
      }
    },
    async saveGame() {
      //make sure user is set
      const user = useSupabaseUser();
      if (user.value) this.game.userID = user.value.id;

      //save game to db here..
      const result = await saveGame(this.game);
      return result;
    },
    async saveSettings() {
      const result = await saveSettings(this.game);
      return result;
    },
    async saveTurns() {
      const result = await saveTurns(this.game);
      return result;
    },
    async addTurn(turn: Models.Turn) {
      this.game.turns.push(turn);
      const result = await saveTurns(this.game);
      console.log("Update turns result: " + result);
      //turn will be in store even though not in db if save fails.. next turn save should try again though..
    },
  },
});
